import React from 'react';
import { Grid, Divider, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
const useStyles = (props) => makeStyles({
    grid: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '60px',
        '@media only screen and (max-width : 758px)': {
            marginTop: '20px',
        },
    },
    text: {
        fontFamily: 'Gotham',
        fontWeight: 400,
        letterSpacing: '-0.56px',
        fontSize: 20,
        '@media only screen and (max-width : 758px)': {
            fontSize: 18,
        },
        textAlign: 'center',
        color: props.color,
    },
    divider: {
        backgroundColor: props.color,
    },
});
const HeaderDivider = (props) => {
    const { color = 'var(--accent)' } = props;
    const classes = useStyles({ color })();
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { className: classes.grid },
            React.createElement(Grid, { item: true, xs: 2, sm: 3 },
                React.createElement(Divider, { className: classes.divider })),
            React.createElement(Grid, { item: true, xs: 8, sm: 6 },
                React.createElement(Typography, { className: classes.text }, props.text)),
            React.createElement(Grid, { item: true, xs: 2, sm: 3 },
                React.createElement(Divider, { className: classes.divider }))),
        React.createElement(Grid, { container: true }, props.children),
        React.createElement(Divider, { className: classes.divider })));
};
export default HeaderDivider;
